<div
  class="item"
  [ngClass]="{ 'item--last': last,'hand':data.velocity }"
  *ngFor="let item of data.items; let i = index; let last = last"
  (click)="data.velocity ? selectItem(item) : null"
>
  <span class="item_title">{{ item.label }}: </span>
  <span class="item_value">{{ item.number | number: "1.0-2" }}</span>
  <span class="item_trend" *ngIf="!last && item.displayArrow">
    <i
      class="fas fa-arrow-up"
      *ngIf="item.up"
    ></i>
    <i
      class="fas fa-arrow-down"
      *ngIf="item.down"
    ></i>
  </span>
</div>

<div class="seasional-box w-100" *ngIf="data.seasonalValues && data.seasonalValues?.length !==0">
  <p class="season-title text-center mb-2">{{data.seasonalTitle}}</p>
    <div class="item" *ngFor="let item of data.seasonalValues; let i = index; let last = last">
      <span class="item_title">{{ item.label }}</span>
      <span class="item_value season-value ms-auto" *ngIf="item.number != null" [matTooltip]="item.number">{{ item.number | number: "1.0-2" }}</span>
      <span class="item_value season-value ms-auto" *ngIf="item.text" [matTooltip]="item.tooltip">{{ item.text }}%</span>
    </div>
</div>
<div *ngIf="data?.velocity" class="item flex-wrap hand pt-1 mt-2" (click)="selectItem(data.generalVelocity)">
  <span class="item_title">General:</span>
  {{(data.generalVelocity || 0 )  | number: "1.0-2"}}
</div>